<div class="mt-4">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li *ngIf="breadCrumbs.length > 0" class="pointer" (click)="isBack()"> <span><img src="../../../assets/images/leftArrow.svg" class="me-2"
              alt=""></span></li>
              <li class="breadcrumb-item" >{{pageName}}</li>
        <li class="breadcrumb-item" [ngClass]="{'active': index+1 == breadCrumbs?.length}" *ngFor="let nav of breadCrumbs; let index=index">{{nav}}<ng-container *ngIf="index  > 1 && breadCrumbs?.length -1 != index">/</ng-container></li>
      </ol>
    </nav>
  </div>
